import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import type { FaqBlock } from '../types';
import { DescriptionBlocks } from '../DescriptionBlocks';
import styles from './Faq.module.css';
interface FaqProps {
  block: FaqBlock;
  blockId: string;
}
export function Faq(t0) {
  const $ = _c(8);
  const {
    block,
    blockId
  } = t0;
  let t1;
  if ($[0] !== block.items || $[1] !== blockId) {
    let t2;
    if ($[3] !== blockId) {
      t2 = (item, idx) => <div key={item.id ?? idx} className={styles.item}><dt id={item.id} className={styles.question}>{item.question}</dt><dd className={styles.answer}><DescriptionBlocks blocks={item.answer} blockIdPrefix={`${blockId}.faq.${item.id ?? idx}`} /></dd></div>;
      $[3] = blockId;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = block.items.map(t2);
    $[0] = block.items;
    $[1] = blockId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== blockId || $[6] !== t1) {
    t2 = <dl className={styles.faq} data-cms-block-id={blockId} data-cms-field="faq">{t1}</dl>;
    $[5] = blockId;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}